import { render } from "./AvatarBorder.vue?vue&type=template&id=9fcafc9e&scoped=true"
import script from "./AvatarBorder.vue?vue&type=script&lang=js"
export * from "./AvatarBorder.vue?vue&type=script&lang=js"

import "./AvatarBorder.vue?vue&type=style&index=0&id=9fcafc9e&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fcafc9e"]])

export default __exports__